// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ops-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: var(--z-index-modal);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  box-sizing: border-box;
  color: var(--dark-color-dark);
}
.ops-dialog-overlay .ops-dialog {
  background: var(--white-color-lightest);
  width: 100%;
  max-height: 90vh;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}
.ops-dialog-overlay .ops-dialog-header {
  min-height: 64px;
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #e0e0e0;
  box-sizing: border-box;
  flex-wrap: wrap;
  row-gap: 8px;
  flex-shrink: 0;
}
.ops-dialog-overlay .ops-dialog-title-area {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.ops-dialog-overlay .ops-dialog-title {
  font-weight: 600;
  font-size: 1.25rem;
  word-break: break-word;
}
.ops-dialog-overlay .ops-dialog-subtitle {
  font-size: 12px;
  color: var(--dark-color-main);
}
.ops-dialog-overlay .ops-dialog-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}
.ops-dialog-overlay .ops-dialog-body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 24px;
  background: #f5f7fa;
  box-sizing: border-box;
}
.ops-dialog-overlay .ops-dialog-footer {
  min-height: 64px;
  padding: 12px 24px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  box-sizing: border-box;
  background: var(--white-color-lightest);
  flex-shrink: 0;
}
.ops-dialog-overlay .bi {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1 !important;
  vertical-align: middle;
}
.ops-dialog-overlay .bi::before {
  vertical-align: 0 !important;
  display: block;
  line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/ops/common/OpsDialog.scss"],"names":[],"mappings":"AACA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;AAAJ;AAEI;EACI,uCAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;EACA,gBAAA;AAAR;AAGI;EACI,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gCAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AADR;AAII;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAFR;AAKI;EACI,gBAAA;EACA,kBAAA;EACA,sBAAA;AAHR;AAMI;EACI,eAAA;EACA,6BAAA;AAJR;AAOI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AALR;AASI;EACI,SAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AAPR;AAUI;EACI,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;EACA,sBAAA;EACA,uCAAA;EACA,cAAA;AARR;AAYI;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;AAVR;AAYQ;EACI,4BAAA;EACA,cAAA;EACA,cAAA;AAVZ","sourcesContent":["// 運営ツールの大きいモーダル（デザイン: 背景 rgba(0,0,0,.5)・ヘッダー64px・本文 #f5f7fa）\n.ops-dialog-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, .5);\n    z-index: var(--z-index-modal);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 24px;\n    box-sizing: border-box;\n    color: var(--dark-color-dark);\n\n    .ops-dialog {\n        background: var(--white-color-lightest);\n        width: 100%;\n        max-height: 90vh;\n        border-radius: 8px;\n        display: flex;\n        flex-direction: column;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, .15);\n        overflow: hidden;\n    }\n\n    .ops-dialog-header {\n        min-height: 64px;\n        padding: 12px 24px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 16px;\n        border-bottom: 1px solid #e0e0e0;\n        box-sizing: border-box;\n        flex-wrap: wrap;\n        row-gap: 8px;\n        flex-shrink: 0;\n    }\n\n    .ops-dialog-title-area {\n        display: flex;\n        flex-direction: column;\n        gap: 2px;\n        min-width: 0;\n    }\n\n    .ops-dialog-title {\n        font-weight: 600;\n        font-size: 1.25rem;\n        word-break: break-word;\n    }\n\n    .ops-dialog-subtitle {\n        font-size: 12px;\n        color: var(--dark-color-main);\n    }\n\n    .ops-dialog-header-right {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n    }\n\n\n    .ops-dialog-body {\n        flex: 1;\n        min-height: 0;\n        overflow-y: auto;\n        padding: 24px;\n        background: #f5f7fa;\n        box-sizing: border-box;\n    }\n\n    .ops-dialog-footer {\n        min-height: 64px;\n        padding: 12px 24px;\n        border-top: 1px solid #e0e0e0;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        flex-wrap: wrap;\n        gap: 12px;\n        box-sizing: border-box;\n        background: var(--white-color-lightest);\n        flex-shrink: 0;\n    }\n\n    // Bootstrap Icons の既定の vertical-align を打ち消し、1em 四方の箱の中央にグリフを置く\n    .bi {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        line-height: 1 !important;\n        vertical-align: middle;\n\n        &::before {\n            vertical-align: 0 !important;\n            display: block;\n            line-height: 1;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
